import { creerBrouillons } from "./brouillon-texte";
import { TEXTE_MAX } from "./contract";

/**
 * Le brouillon local d'une double (plan, partie 2, decision 10) : la saisie que la console n'a
 * pas encore confirmee, gardee dans le navigateur pour qu'un telephone qui perd le reseau, ou
 * une page rechargee, ne perde rien. Une seule cle par double (`histoires:brouillon:<id>`), et
 * la saisie gardee apres « Recharger » a la sienne (`histoires:saisie-gardee:<id>`).
 *
 * Le mecanisme est commun a la console depuis #276 (`brouillon-texte.ts`, ou il est decrit) :
 * ce fichier n'en garde que le prefixe des Histoires et la borne de leur texte.
 */

export {
  type Brouillon,
  INCERTAINS_MAX,
  SAISIES_GARDEES_MAX,
  type SaisieGardee,
} from "./brouillon-texte";

const brouillons = creerBrouillons("histoires", TEXTE_MAX);

export const {
  cleBrouillon,
  analyserBrouillon,
  lireBrouillon,
  ecrireBrouillon,
  effacerBrouillon,
  effacerBrouillonSi,
  brouillonAProposer,
  cleSaisieGardee,
  lireSaisiesGardees,
  garderSaisie,
  oublierSaisie,
} = brouillons;
